export enum POUTER_PATH {
  MAIN = '/',
  STOCKS = 'stock-images',
  IMAGE_CARD = 'images/:id',
  IMAGE = 'images',
  PROFILE = 'profile',
  NOTFOUND = '*',
}
